const RESEND_BUTTON_SELECTOR = "[data-pwreset-resend-button]";
const INIT_ATTRIBUTE = "data-pwreset-init";

export function initPasswordReset(): void {
  const button = document.querySelector<HTMLButtonElement>(RESEND_BUTTON_SELECTOR);
  if (!button || button.hasAttribute(INIT_ATTRIBUTE)) return;
  button.setAttribute(INIT_ATTRIBUTE, "");

  const label = button.dataset.resendLabel ?? "Отправить снова";
  const total = Number.parseInt(button.dataset.resendSeconds ?? "0", 10);

  if (!Number.isFinite(total) || total <= 0) {
    enableButton(button, label);
    return;
  }

  startCountdown(button, label, total);
}

function startCountdown(button: HTMLButtonElement, label: string, seconds: number): void {
  let remaining = seconds;

  const render = (): void => {
    button.disabled = true;
    button.textContent = `${label} (через ${remaining} с)`;
  };

  render();

  const timer = window.setInterval(() => {
    if (!document.contains(button)) {
      window.clearInterval(timer);
      return;
    }
    remaining -= 1;
    if (remaining <= 0) {
      window.clearInterval(timer);
      enableButton(button, label);
      return;
    }
    render();
  }, 1000);
}

function enableButton(button: HTMLButtonElement, label: string): void {
  button.disabled = false;
  button.textContent = label;
}
